/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface Props {
  idEmpresaVendas: string;
}

export function useEquipes(props: Props) {
  const LISTAR_EQUIPES = `/identity/admin/hierarquias/equipes-por-empresa-vendas/v1?idEmpresaVendas=${props.idEmpresaVendas}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_EQUIPES);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["listar-equipes"],
    refetchOnWindowFocus: false,
    enabled: false,
    // refetchInterval: 60000,
    retry: false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar equipes. Motivos:\n ${error.response.data.notifications?.map(
          (item: any) => `${item?.message}`
        )} `,
        { autoClose: 10000 }
      );
    },
  });
  return query;
}
